/* Anacea (refonte) : la réserve de hauteur du thème sous l'en-tête suit la hauteur réelle de l'en-tête. */
(function () {
  function fit() {
    var h = document.querySelector('.theme__header');
    var f = document.querySelector('.header__backfill');
    if (!h || !f || getComputedStyle(h).position !== 'absolute') return;
    f.style.height = h.offsetHeight + 'px';
    f.style.overflow = 'hidden';
  }
  fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
})();
